import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./InviteModal.css";
import Select from "react-select";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const options = [
  { value: "stg90", label: "STG90" },
  { value: "pba", label: "PBA" },
  { value: "boa", label: "LAB" },
  { value: "club84", label: "CCA" },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    border: state.isFocused ? '1px solid #ccc' : '1px solid #ddd',
    outline: 'none',
    '&:hover': {
      border: '1px solid #aaa',
    },
  })
};

const InviteModal = ({ isOpen, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  const sendInvite = async () => {
    if (!name || !email || !selectedOption) {
      toastr.error("Please fill in all fields");
      throw new Error("Please fill in all fields")
    }

    const payload = {
      name: name,
      email: email,
      course_code: selectedOption.value,
    };
    try {
      const response = await apiServiceHandler("POST", "api/auth/invite/user", { ...payload });
      // console.log(response, 'Data is here....');
      if (response.auth) {
        toastr.success("User invited successfully");
        setName("");
        setEmail("");
        setSelectedOption(null);
        onClose();
      } else {
        toastr.error(response.message || "Failed to invite user. Please try again.");
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error(error.response);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Invite New Member</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Name</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={name}
                onChange={(e) => setName(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Email</div>
            <div className="form-input__wrapper">
              <input
                type="email"
                className="form-input__input"
                value={email}
                onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>
          <div className="select-invite-form__field">
            <div class="select__label">Select Course</div>
            <Select
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={options}
              placeholder=""
              styles={customStyles}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: '1rem' }}>
        <button className="send-invite__btn" onClick={sendInvite}>
          <span className="send-invite-button__label">Send Invite</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InviteModal;
